import React from 'react';

const CheckIcon = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="#00CC99" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.0748 20.893C42.9623 21.7628 42.9767 23.1873 42.107 24.0748L27.407 39.0748C26.9838 39.5067 26.4046 39.75 25.8 39.75C25.1954 39.75 24.6162 39.5067 24.193 39.0748L17.893 32.6463C17.0233 31.7588 17.0377 30.3342 17.9252 29.4645C18.8127 28.5947 20.2372 28.6091 21.107 29.4966L25.8 34.2854L38.893 20.9252C39.7628 20.0377 41.1873 20.0233 42.0748 20.893Z"
    />
  </svg>
);

export default CheckIcon;
